module.exports = __webpack_public_path__ + "static/media/strapi.a0d8a6a8.svg";